const initExploreMenu = () => {
  // const explore = document.getElementById("explore");
  // if(explore){
  //   const triggerExplore = explore.querySelector(".triggerMenu");
  //   if(triggerExplore){
  //     explore.addEventListener("mouseenter", function(){
  //       const levelOne = explore.querySelector("#levelOne");
  //       if(levelOne){
  //         levelOne.classList.remove("hidden");
  //       }
  //     });

  //     const triggerLevelTwo = explore.querySelectorAll(".triggerLevelTwo");
  //     if(triggerLevelTwo){
  //       triggerLevelTwo.forEach(function(trigger){
  //         trigger.addEventListener("mouseenter", function(){
  //           const levelTwo = explore.querySelector("#levelTwo");
  //           const levelThree = explore.querySelector("#levelThree");
  //           if(levelTwo){
  //             levelTwo.classList.remove("hidden");
  //             levelThree.classList.add("hidden");
  //           }
  //         });
  //       });
  //     }

  //     const triggerLevelThree = explore.querySelectorAll(".triggerLevelThree");
  //     if(triggerLevelThree){
  //       triggerLevelThree.forEach(function(trigger){
  //         trigger.addEventListener("mouseenter", function(){
  //           const levelThree = explore.querySelector("#levelThree");
  //           if(levelThree){
  //             levelThree.classList.remove("hidden");
  //           }
  //         });
  //       });
  //     }

  //     const toActive = explore.querySelectorAll(".toActive");
  //     if(toActive){
  //       toActive.forEach(function(link){
  //         link.addEventListener("mouseenter", function(){
  //           link.classList.add("text-red");
  //         });

  //         link.addEventListener("mouseleave", function(){
  //           link.classList.remove("text-red");
  //         });
  //       });
  //     }
  //   }
  // }

  // const allLevelTwo = document.querySelectorAll('.explore__level2');
  // if(allLevelTwo){
  //   allLevelTwo.forEach(level => {
  //     const items = level.querySelectorAll('.item__level2');
  //     if(items){
  //       items.forEach(item => {
  //         const levelThree = item.querySelector('.explore__level3');
  //         if(levelThree){
  //           item.addEventListener('mouseenter', () => {
  //             const alreadyOpenedLevelThree = level.querySelector('.force-display');
  //             if(alreadyOpenedLevelThree){
  //               alreadyOpenedLevelThree.classList.remove('force-display');
  //             }

  //             levelThree.classList.add('force-display');
  //             const closestLevelTwo = levelThree.closest('.explore__level2');
  //             const closestLevelOne = levelThree.closest('.explore__level1');
  //             closestLevelTwo.classList.add('force-display');
  //             closestLevelOne.classList.add('force-display');
  //             window.setTimeout(() => {
  //               levelThree.classList.remove('force-display');
  //               closestLevelTwo.classList.remove('force-display');
  //               closestLevelOne.classList.remove('force-display');
  //             }, 5000);
  //           });
  //         }
  //       });
  //     }
  //   });
  // }

  const allLevelOne = document.querySelectorAll('.item__level1');
  if(allLevelOne){
    allLevelOne.forEach(levelOne => {
      levelOne.addEventListener('mouseenter', () => {
        if(!levelOne.classList.contains('height-set')){
          const levelTwoBlock = levelOne.querySelector('.explore__level2');
          const allLevelThreeBlocks = levelOne.querySelectorAll('.explore__level3');
          if(levelTwoBlock && allLevelThreeBlocks){
            allLevelThreeBlocks.forEach(block => {
              block.style.height = levelTwoBlock.offsetHeight + 'px';
            });
          }

          levelOne.classList.add('height-set');
        }
      });
    });
  }
}

export { initExploreMenu }
